export default __webpack_public_path__ + "static/media/bannerImg.b4b2423e.png";